var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFarmHoliday = function SvgFarmHoliday(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.49998C7.30606 4.02778 2.66667 9.66664 1 12L8 10.5L6.5 13L11 11L12.5 13L14 11L17.5 12.5L16 10L22.5 12.5C21 9.83331 18 5 12.5 4.49998Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.5V21.5C4 22.0523 4.44772 22.5 5 22.5H18.5C19.0523 22.5 19.5 22.0523 19.5 21.5V11.5",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 22.5V18.5C9.5 17.1193 10.6193 16 12 16C13.3807 16 14.5 17.1193 14.5 18.5V22",
    stroke: "#282828",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1L12 4",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2L12 4L14 2",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgFarmHoliday;